import { render, staticRenderFns } from "./DemandForm.vue?vue&type=template&id=60ca4a6a&scoped=true"
import script from "./DemandForm.vue?vue&type=script&lang=js"
export * from "./DemandForm.vue?vue&type=script&lang=js"
import style0 from "./DemandForm.vue?vue&type=style&index=0&id=60ca4a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ca4a6a",
  null
  
)

export default component.exports